'use client';

import { PaybackAccountDataFetchProvider } from '@packages/order/src/components/Payback/PaybackAccountDataFetchProvider';
import { PaybackDisconnected } from '@packages/order/src/components/Payback/PaybackDisconnected';
import { PaybackReauthenticate } from '@packages/order/src/components/Payback/PaybackReauthenticate';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { usePaybackConnectionStatus } from '@packages/modules/src/Payback/hooks/usePaybackConnectionStatus';
import { OfflineNotification } from '../OfflineNotification/OfflineNotification';
import { PaybackConnected } from './PaybackConnected.client';

export const PaybackPage = () => {
  const {
    isOffline,
    isDisconnected,
    isInactive,
    isEstablished,
    isReauthenticationNeeded,
    isLoading,
  } = usePaybackConnectionStatus();

  if (isLoading) {
    return <Skeleton className="my-2 h-32 w-full" />;
  }

  if (isOffline) {
    return <OfflineNotification />;
  }

  return (
    <>
      {isDisconnected && <PaybackDisconnected enableSignIn />}
      {isInactive && <PaybackDisconnected enableSignIn={false} />}
      {isEstablished && (
        <PaybackAccountDataFetchProvider>
          <PaybackConnected />
        </PaybackAccountDataFetchProvider>
      )}
      {isReauthenticationNeeded && <PaybackReauthenticate />}
    </>
  );
};
// eslint-disable-next-line import-x/no-default-export
export default PaybackPage;
